import { render, staticRenderFns } from "./ReturnDeliveryDialog.vue?vue&type=template&id=554ef804&"
import script from "./ReturnDeliveryDialog.vue?vue&type=script&lang=ts&"
export * from "./ReturnDeliveryDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports